import axios from 'axios'

import type { ImageFile } from '@/types/types'

export default function useWebapp() {
  const getWebapp = async () => {
    try {
      const { data: dataWebapp } = await axios.get('/webapps')
      return dataWebapp.data
    } catch (error) {
      console.error(error)
    }
  }

  const saveWebapp = async ({
    color,
    image,
    hasFormCompletion,
    hasCustomerStatus,
    statusSegmentIds,
    id
  }: {
    color?: string
    image?: ImageFile
    hasFormCompletion?: boolean
    hasCustomerStatus?: boolean
    statusSegmentIds?: number[]
    id?: number
  }) => {
    const payload: {
      color: string
      hasFormCompletion?: boolean
      hasCustomerStatus?: boolean
      statusSegmentIds?: number[]
      images?: string[]
    } = {
      color: color.replace('#', '')
    }

    let webappId = id
    if (!id) {
      const { data: dataWebapp } = await axios.get('/webapps')
      webappId = dataWebapp.data.id
    }

    if (hasFormCompletion !== undefined) payload.hasFormCompletion = hasFormCompletion
    if (hasCustomerStatus !== undefined) payload.hasCustomerStatus = hasCustomerStatus
    if (statusSegmentIds !== undefined) payload.statusSegmentIds = statusSegmentIds
    if (image) payload.images = [image.path]

    return await axios.put(`/webapps/${webappId}`, payload)
  }

  return { getWebapp, saveWebapp }
}
